export default "__VITE_ASSET__BzYKtTlg__"